import { Injectable } from '@angular/core';
import { IgenomicsState } from '../../../core/interfaces/genomics-state.interface';
import { Store } from '@ngrx/store';
import { IAberrationsState } from '../store/aberrations.reducer';
import * as immutable from 'immutable';
import {
    initActionCreator,
    setFilteredResultsActionCreator, setFilteredResultsCountActionCreator,
    setFilterQueryActionCreator,
    setLoadingStatusActionCreator,
    setResultsActionCreator
} from '../store/aberrations.actions';
import { IAberrations } from '../interfaces/aberrations.interface';
import { getActiveRecord } from '../../../workflow-config/utils/store.utils';
import { Observable } from 'rxjs/Observable';
import { WorkflowConfigService } from '../../../workflow-config/services/workflow-config.service';

@Injectable()
export class AberrationsActionCreatorService {
  private store: Store<IAberrationsState>;

  constructor(store: Store<IgenomicsState>, private workflowConfigService: WorkflowConfigService) {
    this.store = store.select('tests', 'aberrations', 'data') as any;
  }


  /**
   * init the state
   */
  public initState() {
    this.store.dispatch(initActionCreator(null));
  }
  /**
   * setting the filtered ids list
   * @param {string} type
   * @param {string[] | Set<string>} idsArray
   * @param {number} count
   */
  public setFilteredList(type: string, idsArray: string[] | Set<string>, count: number = null) {
    this.store.dispatch(setFilteredResultsActionCreator({type:type,results:idsArray}));
    if(count !== null) {
        this.store.dispatch(setFilteredResultsCountActionCreator({type, count}));
    }
  }


  /**
   * setting the current filter per aberration type
   * @param {string} type
   * @param {string} filterQueryString
   * @param filterQueryObject
   */
  public setFilters(type: string, filterQueryString: string, filterQueryObject: any) {
      (<any> this.store.select('filteredResults'))
      .dispatch(setFilterQueryActionCreator({ type: type, filterQueryString: filterQueryString, filterQueryObject: filterQueryObject}));
  }

  /**
   * appending data to the filtered ids list
   * @param {string} type
   * @param {string[]} idsArray
   */
  public appendFilteredList(type: string, idsArray: string[]) {
    this.getState(['filteredResults'])
      .filter((state) => state && !!state.has(type))
      .take(1)
      .map(state => state.get(type))
      .subscribe((ids: immutable.Set<string> | Array<string>) => {
        this.setFilteredList(type, [...<Array<string>> ids, ...idsArray]);
      });
  }

  /**
   * setting the resolved ids
   *
   * @param {string} type
   * @param {IAberrations[]} aberrations
   */
  public setResolveAberrations(type: string, aberrations: IAberrations[]) {
      (<any> this.store.select('results')).dispatch(setResultsActionCreator({ type, aberrations: [...aberrations]}));
  }

  /**
   * toggle loader on and of
   * @param {string} type
   * @param {boolean} status
   */
  public setLoadingStatus(type: string, status: boolean) {
      (<any> this.store.select('loadingStatus'))
      .dispatch(setLoadingStatusActionCreator({ type, status}));
  }

  public getActiveCacheKey(): Observable<string> {
    return this.workflowConfigService.getCacheKey();
  }

  public getState(props: Array<keyof IAberrationsState> = [], getByWorkflowId: boolean= true) {
    let state: any = this.store;
    for (const prop of props) {
      state = state.select(prop);
    }
    return state
      .flatMap(value => props.length > 0 && getByWorkflowId ? getActiveRecord(value, value) : Observable.of(value));
  }


}
